import { render, staticRenderFns } from "./IntegrationsListPage.vue?vue&type=template&id=b9e1ca52&scoped=true&"
import script from "./IntegrationsListPage.vue?vue&type=script&lang=js&"
export * from "./IntegrationsListPage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsListPage.vue?vue&type=style&index=0&id=b9e1ca52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e1ca52",
  null
  
)

export default component.exports